export default "__VITE_ASSET__CJ6na$vb__"